module.exports = __webpack_public_path__ + "img/hail.0417d687.jpg";